import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import api from "@/lib/api";
import WhatsAppLink from "@/components/admin/WhatsAppLink";
import { renewalReminder, readingReminder } from "@/lib/waTemplates";

function Row({ c }) {
  const rd = c.kind === "reading";
  const kid = { name: c.child_name, grade: c.grade };
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm bg-slate-900 rounded-xl px-3 py-2" data-testid={rd ? `admin-expiring-reading-${c.child_id}` : `admin-expiring-${c.child_id}`}>
      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${c.expired ? "bg-red-600" : "bg-amber-300 text-slate-900"}`}>
        {c.expired ? "Ended" : c.days_left <= 0 ? "Today" : `${c.days_left} day${c.days_left === 1 ? "" : "s"} left`}
      </span>
      <span className="font-semibold">{c.child_name} · G{c.grade}</span>
      {rd ? <span className="rounded-full bg-sky-700 px-2 py-0.5 text-xs font-semibold" data-testid={`admin-expiring-reading-langs-${c.child_id}`}>Reading kit {c.langs.map((l) => l.toUpperCase()).join(" + ")}</span>
        : <span className="text-slate-400">{c.subjects.join(", ")}</span>}
      <span className="text-slate-400">until {new Date(c.paid_until).toLocaleDateString()}</span>
      <a href={`mailto:${c.parent_email}`} className="ml-auto text-blue-300 underline">{c.parent_name} · {c.parent_email}</a>
      <WhatsAppLink number={c.parent_whatsapp} message={rd ? readingReminder(c.parent_name, kid, c.langs) : renewalReminder(c.parent_name, kid)}
        messageLabel={rd ? "Send Reading kit reminder" : "Send renewal reminder"} consentAccount={c.parent_consent_account} consentMarketing={c.parent_consent_marketing}
        name={c.parent_name} testId={rd ? `expiring-reading-whatsapp-${c.child_id}` : `expiring-whatsapp-${c.child_id}`} />
    </div>
  );
}

export default function ExpiringAccess() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/expiring").then(({ data }) => setList(data.children)).catch(() => setList([])); }, []);
  if (!list) return null;
  return (
    <div className="bg-slate-800 rounded-2xl border-2 border-amber-400/60 p-4" data-testid="admin-expiring">
      <p className="font-bold flex items-center gap-2"><CalendarClock size={18} className="text-amber-300" /> Access ending in the next 7 days · subjects & Reading kit</p>
      {list.length === 0 ? (
        <p className="text-slate-400 text-sm mt-2" data-testid="admin-expiring-empty">No child's access ends in the next 7 days.</p>
      ) : (
        <div className="mt-3 space-y-2">
          {list.map((c) => <Row key={`${c.child_id}-${c.kind}`} c={c} />)}
        </div>
      )}
    </div>
  );
}
